import LinearActivityBar from 'components/ProgressBar/LinearActivityBar';
import i18next from 'i18next';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import arrowWhiteIcon from '../../assets/img/icons/arrow_right_white.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import {
  TableItem,
  TableRowAndBudgetCollapseContainer,
} from '../../styledComponents/ProjectsNew';
import {
  CommonFlex,
  CommonText,
  Container,
  InputField,
  TableText,
} from '../../styledComponents/common';
import { CheckListStatus } from '../../styledComponents/tasks';
import { TransferringRequestsTable } from '../../styledComponents/transferringRequests';
// import {
//   CheckListStatus,
//   TableItem,
//   TableRowAndBudgetCollapseContainer,
//   TableText,
//   TaskTable,
// } from '../../styledComponents/tasks';
import { ListItemsContainer } from '../FieldServices/JobSites/jobSitesStyles';
import { ExpandIcon, ProjectExpandButton } from '../Projects/projectsStyles';
import TaskEvidence from '../Tasks/TaskDetails/taskEvidence';
import { AssigneeRoundImg, CollapseSection } from '../Tasks/tasksStyles';
import AssigneeTooltip from 'components/Tooltip/AssigneeTooltip';
import avatar5 from '../../assets/img/avatar_5.svg';
const TransferringRequestsList = ({
  isLoading,
  transferringRequestsList,
  selectedRequest,
  selectRequest,
}) => {
  const { t } = useTranslation();
  const [list, setList] = useState([]);
  useEffect(() => {
    if (transferringRequestsList && transferringRequestsList.length > 0) {
      const updatedList = transferringRequestsList.map(request => ({
        ...request,
        item: request?.item?.name || 'N/A',
        from_office: request.from_office || { id: 'N/A', name: 'N/A' },
        to_office: request.to_office || { id: 'N/A', name: 'N/A' },
        created_by: request.created_by || {
          first_name: 'N/A',
          last_name: '',
          email: 'N/A',
        },
        approved_by: request.approved_by || {
          first_name: 'N/A',
          last_name: '',
        },
        evidences: request.evidences || [],
      }));
      setList(updatedList);
    } else {
      setList([]);
    }
  }, [transferringRequestsList]);

  return (
    <Container style={{ paddingBottom: '20px', overflowX: 'auto' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : list && list.length > 0 ? (
        <>
          <TransferringRequestsTable heading>
            <TableItem>
              <TableText>{t('request_no')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('date_and_time')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('item_name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('quantity')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('from_office')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('requester_name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('to_office')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('assignee')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('approval_holder')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('status')}</TableText>
            </TableItem>
            <TableItem />
          </TransferringRequestsTable>
          {list?.map(request => {
            return (
              <TableRowAndBudgetCollapseContainer key={request.id}>
                <TransferringRequestsTable>
                  <TableItem>
                    <TableText
                      hoverPointer
                      hoverUnderline
                      name
                      fontWeight={
                        selectedRequest &&
                        selectedRequest.id === request.id &&
                        '600'
                      }
                      onClick={() => selectRequest(request)}
                    >
                      {request.request_no}
                    </TableText>
                  </TableItem>
                  <TableItem>
                    <TableText name>
                      {moment(request.created_at).format('DD/MM/YYYY HH:mm')}
                    </TableText>
                  </TableItem>
                  <TableItem>
                    <TableText name>{request.item}</TableText>
                  </TableItem>
                  <TableItem>
                    <TableText name>{request.quantity}</TableText>
                  </TableItem>
                  <TableItem>
                    <TableText name>
                      {
                        request.from_office?.public_zone_name +
                          ' - ' +
                          request.from_office?.office_name
                      }
                    </TableText>
                  </TableItem>
                  <TableItem>
                    <TableText name>
                      {request.created_by?.first_name}{' '}
                      {request.created_by?.last_name}
                    </TableText>
                  </TableItem>
                  <TableItem>
                    <TableText name>
                      {request.to_office?.public_zone_name +
                        ' - ' +
                        request.to_office?.office_name}
                    </TableText>
                  </TableItem>
                  <TableItem padding="10px 0 10px 10px">
                    {request.assignees &&
                    request.assignees.id ? (
                      <AssigneeRoundImg
                        image={request.assignees.avatar || avatar5}
                      >
                        <AssigneeTooltip
                          toolTipText={`${request.assignees.first_name}${
                            request.assignees.last_name
                              ? ` ${request.assignees.last_name}`
                              : ``
                          }`}
                          phone={request.assignees.phone}
                          top="-60px"
                          left="-55px"
                        />
                      </AssigneeRoundImg>
                    ) : null}
                  </TableItem>
                  <TableItem>
                    <TableText name>
                      {request?.approved_by?.first_name}{' '}
                      {request?.approved_by?.last_name}
                    </TableText>
                  </TableItem>
                  <TableItem>
                    <CheckListStatus
                      status={request.status ? request.status : 'to do'}
                    >
                      {i18next.language && i18next.language === 'en'
                        ? t(request?.status).toUpperCase()
                        : t(request?.status)}
                    </CheckListStatus>
                  </TableItem>
                  <TableItem alignContent="start">
                    <CommonFlex gap="12px" wrap="wrap">
                      <ProjectExpandButton
                        margin="0"
                        onClick={() => {
                          if (
                            selectedRequest?.id === request.id ||
                            selectedRequest === request
                          ) {
                            selectRequest(null);
                          } else selectRequest(request);
                        }}
                      >
                        <ExpandIcon
                          src={arrowWhiteIcon}
                          alt=""
                          open={
                            selectedRequest && selectedRequest.id === request.id
                          }
                        />
                      </ProjectExpandButton>
                    </CommonFlex>
                  </TableItem>
                </TransferringRequestsTable>{' '}
                <CollapseSection
                  open={selectedRequest && selectedRequest.id === request.id}
                >
                  <Container padding="30px" borderColor="#977C70" margin="20px">
                    <TaskEvidence evidences={request.evidences} />
                  </Container>
                </CollapseSection>
              </TableRowAndBudgetCollapseContainer>
            );
          })}
        </>
      ) : (
        <NoDataComponent
          title={t('no_requests_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default TransferringRequestsList;
